import React, { useState } from 'react';
import { motion } from 'framer-motion';

const LeftArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M9.707 4.293a1 1 0 00-1.414 1.414L11.586 8H4a1 1 0 100 2h7.586l-3.293 3.293a1 1 0 001.414 1.414l5-5a1 1 0 000-1.414l-5-5z" clipRule="evenodd" />
  </svg>
);

const RightArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10.293 15.707a1 1 0 010-1.414L13.586 11H4a1 1 0 110-2h9.586l-3.293-3.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
  </svg>
);

export default function ClientIdentification({ initial, onNext, onError }) {
  const [formData, setFormData] = useState({
    name: initial.name || '',
    whatsapp: initial.whatsapp || '',
    interest: initial.interest || ''
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Nome é obrigatório';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      onNext({
        name: formData.name,
        whatsapp: initial.whatsapp || '',
        interest: ''
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="space-y-8"
    >
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">
          Como posso te chamar?
        </h2>
        <p className="text-gray-600">
          Digite seu primeiro nome ou apelido
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Nome
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={`w-full px-4 py-3 rounded-xl border ${
              errors.name ? 'border-red-500' : 'border-gray-200'
            } focus:border-[#e91e63] focus:ring-2 focus:ring-[#e91e63]/20 transition-all duration-200`}
            placeholder="Seu primeiro nome ou apelido"
          />
          {errors.name && (
            <p className="mt-1 text-sm text-red-500">{errors.name}</p>
          )}
        </div>

        <div className="flex justify-between pt-6">
          <motion.button
            type="button"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onError('Voltar')}
            className="px-6 py-3 text-gray-600 hover:text-gray-800 transition-colors flex items-center"
          >
            <LeftArrow /> Voltar
          </motion.button>

          <motion.button
            type="submit"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="px-8 py-3 bg-[#e91e63] text-white rounded-xl hover:bg-[#d81557] transition-colors flex items-center"
          >
            Continuar <RightArrow />
          </motion.button>
        </div>
      </form>
    </motion.div>
  );
}
